export const alertInformativo = {
  compania:
    'en esta seccion podras crear o ver la compañia que se encuentra creada, asi como editar o ver sus detalles.',
  sucursal:
    'en esta seccion podras crear ver las sucursales pertenecientes a la compañia que se encuentra creada, asi como editar o ver sus detalles.',
  area: 'en esta seccion podras crear ver las areas pertenecientes a la compañia que se encuentra creada, asi como editar o ver sus detalles.',
  cargo:
    'en esta seccion podras crear ver los cargos pertenecientes a la compañia que se encuentra creada, asi como editar o ver sus detalles.',
  usuariospermisos:
    'en esta seccion podras crear ver los permisos de los ususarios pertenecientes a la compañia que se encuentra creada, asi como editar o ver sus detalles.',
  logacciones:
    'en esta seccion podras crear ver los logs de acciones de la compañia que se encuentra creada, asi como editar o ver sus detalles.',
  empleado:
    'en esta seccion podras crear ver los empleados de la compañia que se encuentra creada, asi como editar o ver sus detalles.',
  turnos:
    'en esta seccion podras crear ver los turnos de la compañia que se encuentra creada, asi como editar o ver sus detalles.',
  parametros:
    'en esta seccion podras crear ver los parametros de la compañia que se encuentra creada, asi como editar o ver sus detalles.',
  tipoNovedades:
    'en esta seccion podras crear ver los tipos de novedades de la compañia que se encuentra creada, asi como editar o ver sus detalles.',
  novedadesTurnos:
    'en esta seccion podras crear ver las novedades en los turnos de la compañia que se encuentra creada, asi como editar o ver sus detalles.',
  employeeTerminal:
    'en esta seccion podras crear ver las terminales de control accesos creada, asi como editar o ver sus detalles. url: https://control-tiempos.qihotels.net',
  employeeTerminalDescansos:
    'en esta seccion podras crear ver las terminales de descansos empleados creados, asi como editar o ver sus detalles. url: https://control-descansos.qihotels.net',
  controlTiempos:
    'en esta seccion podras  ver los empleados en turno, asi como ver quienes llegaron tarde en el momento y podra sacar de turnos a quienes no hallan salido todavia.',
  codigosexpressChecking:
    'en esta seccion podras crear ver los codigos express checking que se encuentra creados, asi como editar o ver sus detalles.',
  registrosexpressChecking:
    'en esta seccion podras crear ver los registros express checking que se encuentra creados, asi como editar o ver sus detalles.',
  reporteControlTiempos:
    'en esta seccion podras generar reportes de asistencia empelados por fechas.',
  camposOrdenesServicios:
    'en esta seccion podras ver y configurar los campos para el modulo ordenes de servicios, estos se van a usar al momento de crear las cotizaciones o las ordenes de servicios de esta manera quedan dinamicos.',
  asignarCamposOrdenesServicios:
    'en esta seccion podras ver y asignar campos asignados a ordenes de servicios.',
  ordenesServicios: 'en esta seccion podras ver y gestionar ordenes de servicios.',
  crearOrdenesServicios: 'en esta seccion podras crear ordenes de servicios.',
  cotizaciones: 'en esta seccion podras ver y gestionar cotizaciones.',
  crearCotizacion: 'en esta seccion podras crear cotizaciones.',
  areasCalificaciones:
    'Administra las áreas del hotel para agrupar las calificaciones de las encuestas.',
  gestionDispositivos:
    'Administra los dispositivos para agrupar las calificaciones de las encuestas.',
  asignarEncuestas:
    'en esta seccion podras crear y gestionar las asignaciones de encuestas a dispositivos.',
  configuracionEncuestas:
    'Crea y administra las encuestas que se usarán en tu hotel para recolectar el feedback de los huéspedes.',
  gestionCalificaciones:
    'Revisa, filtra y gestiona las calificaciones enviadas por tus clientes a través de los dispositivos instalados.',
  reglasyAlertas:
    'Administra las reglas de alertas y los usuarios que recibirán las notificaciones por eventos negativos o seguimiento.',
  sla: 'Configura los tiempos de respuesta esperados (SLA) y administra las palabras clave para automatizar respuestas rápidas.',
  resumenReputacion:
    'Visualiza un resumen completo de la reputación online, monitoreando tu rendimiento en distintas plataformas en tiempo real.',
  resumenCalificaciones:
    'Administración y configuración del sistema de encuestas y métricas. Diseña, configura y gestiona encuestas inteligentes alineadas a la experiencia del cliente y a la calidad del servicio.',
  plantillasRespuestas:
    'Crea y administra plantillas de respuestas predefinidas para contestar rápidamente a los comentarios y calificaciones de tus huéspedes.',
  linksEncuestas:
    'Administra los enlaces generados para encuestas y su disponibilidad para los clientes.',
  plantillaTurnos:
    'Gestiona plantillas de turnos y horas para la asignación automática de personal.',
  reglasProgramacion:
    'Establece reglas y límites de horas o descansos para la programación de turnos por cargo.',
  requerimientoPersonal:
    'Define y gestiona los requerimientos de personal para los distintos turnos y cargos.',
  generadorTurnos:
    'Genera los horarios de trabajo del mes de forma inteligente utilizando Inteligencia Artificial. Revisa que todas tus reglas estén configuradas antes de generar.',
  crearRequerimientoPersonal:
    'en esta seccion podras crear requerimientos de personal para turnos.',
};
